import { Command, StateService, Random } from 'flux-core';
import { Injectable } from '@angular/core';
import { DiagramLocatorLocator } from '../../diagram/locator/diagram-locator-locator';
import { ShapeManageService } from './../../../editor/feature/shape-manage.svc';
import { DiagramChangeService } from '../../diagram/diagram-change.svc';
import { PresentationLocator } from '../presentation-locator.svc';
import { AbstractDiagramChangeCommand } from './../../../editor/diagram/command/abstract-diagram-change-command.cmd';
import { PresentingService } from '../presenting.svc';
import { take, tap } from 'rxjs/operators';
import { ShapeModel } from '../../shape/model/shape.mdl';

/**
 * This command is used to clone a presentation.
 * With the, when a presentation is cloned, the shapes within the slides also get cloned.
 */
@Injectable()
@Command()
export class DuplicatePresentation extends AbstractDiagramChangeCommand {

    public data: {
        presentationId: string;
        diagramId: string;
        shapeData: any;
    };

    constructor (
        ds: DiagramChangeService,
        protected state: StateService<any, any>,
        protected dl: DiagramLocatorLocator,
        protected pl: PresentationLocator,
        protected shapeManageSvc: ShapeManageService,
        protected presentingService: PresentingService,
    ) {
        super( ds )/* istanbul ignore next */;
    }

    public prepareData() {
        if ( !this.data.presentationId ) {
            return;
        }

        const newPresentationId = Random.presentationId();

        for ( let i = 0; i < this.data.shapeData.length; i++ ) {
            for (const shapeId in this.data.shapeData[i]) {
                const shape = this.data.shapeData[i][shapeId] as ShapeModel;
                if ( shape.isSlideShape && shape.data[ PresentingService.PRESENTATION_DATA_KEY ].value ) {
                    shape.data[ PresentingService.PRESENTATION_DATA_KEY ].value = newPresentationId;
                }
                this.changeModel.shapes[ shapeId ] = shape;
            }
        }

        return this.pl.getPresentation( this.data.presentationId, this.state.get( 'CurrentUser' )).pipe(
            take( 1 ),
            tap( presentation => {
                const newSlides = {}

                Object.keys( presentation.slides ).forEach( slideId => {
                    newSlides[slideId] = { ...presentation.slides[slideId], diagramId: this.data.diagramId, presentationId: newPresentationId }
                });

                const newPresentation = {
                    ...presentation,
                    slides: newSlides,
                    id: newPresentationId,
                    userId: this.state.get( 'CurrentUser' ),
                    presentingState: { isPresenting: false, presenterId: '' },
                    name: presentation.name + ' - Copy',
                    isPrivate: true,
                };

                this.resultData = newPresentation;
                this.presentingService.showDuplicateSuccessNotification();
                this.state.set( 'CurrentPresentation', newPresentationId );
            })
        )
    }
}
